import { auth } from 'google-auth-library';
import { sumOfReportData } from 'views/charts/utils';

export const FormatReportData = (reportData) => {
  return {};
};

export const GetTotalViews = (reportData) => {
  const dataForCurDuration = 0;
  const dataForPrevDuration = 0;
  const percent =
    ((dataForCurDuration - dataForPrevDuration) / dataForCurDuration) * 100;
  return { total: dataForCurDuration, percent };
};

export function addDaysToDate(date, days) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}

export function getReportStartDate(startDateString, endDateString) {
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  const dayDiff = Math.floor((endDate - startDate) / (24 * 60 * 60 * 1000)) + 1;
  // console.log('dayDiff', dayDiff);
  const newDate = addDaysToDate(startDate, -dayDiff);

  const year = newDate.getFullYear();
  const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
  const day = newDate.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export const getDateRangeForReport = (start, end) => {
  const newDate = getReportStartDate(start, end);
  // console.log('newDate', newDate);
  return {
    startDate: newDate,
    endDate: end,
  };
};

export const total = (data, key) =>
  data?.reduce((total, obj) => total + parseInt(obj?.[key]), 0);

export const percent = (prevTotal, currentTotal) => {
  return prevTotal === 0 || prevTotal === 'NaN' || currentTotal === 'Infinity'
    ? 100
    : (
        ((parseFloat(currentTotal) - parseFloat(prevTotal)) /
          parseFloat(prevTotal)) *
        100
      ).toFixed(1);
};
export const divideData = (data, dateRange) => {
  if (!data) return;
  const currentData = sumOfReportData(data, dateRange.reportDates);
  const prevData = sumOfReportData(data, dateRange.prevDates);

  return { prevData: prevData, currentData };
};

export const totalBounceRate = (data) => {
  if (!data) return;
  const bounceRateList = data.filter((item) => item.bounceRate);

  return (
    (bounceRateList.reduce((total, obj) => {
      return total + parseInt(obj.bounceRate);
    }, 0) /
      bounceRateList.length) *
    100
  );
};

async function getAccessToken() {
  try {
    // Replace with the actual content of your Google service account JSON file

    // "{  'type': 'service_account',  'project_id': 'vizion-366603', 'private_key_id': 'a9bdf00f5f3d95d40197c65ab1c54314cb935924',  'private_key': '-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQCRwRnCFIy3kOHo\ndjwDlMY5e0yz+i9+OM78R6bjbqiAGgSubBvVz4Nq3nGQWh4BIhP5pHeISTxQ6M0T\nNd67O8df+V8QdVMFsg5AiXLkNqulCVAUbUx4nhaXeheRCOAuJl7jM3ZzVFDIDRIk\nAz8nd2am8hgoQLuMt5FQ/eLlbt4mNY/6O0TF3xJGfq4dB/3LFHUuN4d7UWbYrHTb\nNedgaUBogA3pHz77/DhKy9d1stJz2vMK387jvtrbi6sZDTE2Argl3vDaLJ/ex+9N\nI6FIzRAhAcjsnKxn2rWzlQAb+3e/CB5aejXT1Y3YjHIMoAiWbjxoLMV/aX+XUazF\n1bw952QBAgMBAAECgf951vGxS3xV9sbhi/SfCb6qTmfQC1OoL9TXDw5zEA3LB/Th\n2X1rPgydSVWlVa+/Qr1v8gv54T6KZBEJ/f4yhcYkdFEDcQ/1suI3EK76FrllPGO0\nr6k9Kum3tlf85W6BJZIsWtipj9H3aPXBJPWmCCnHZJjNDU+6Ubkn+xOwtvz88oZ1\nVAselF79l5xtnR0vEj1fmFA4NSQWgHn1egSAXVL1QjSIssWVpxwTamqsL6uMQSEB\nsUDj+vDQ9dGBL/0y150g1ZPFjVPYoCPN8QbYTLmkIDwKRVXyZow0CHmWhfU2Latg\nmUTcMj7MuawC7tg4e56t3rwe2cpolN9JPyYzs1kCgYEAwatHZfxxkUXkTLHc76LG\nb531mAHnft3Aegm5k+gdL5h1zX9Rax055+NcnZE5kbrjQO/QFnqEwJYlry2h3ovd\nAU7vp+jzz4k+o45TMiqyPZ3vo+OLbXNL61acvM4j4rAiV9M2r93toV8/lQ8mFT6P\nJggvuBacioZFKKtnYUR9CH8CgYEAwKoLMf1RZzLj1Dw+vkACJobim/UzpKLTYSVH\nt/ttxQ/w71DMQ/r2HnxWtjK0p+tNBFXkWAND3+XQ43Aygg2ji884m/Sn8oye2GPN\nDBVXJlIzyevApZLHnpNNlRpnrUzwryJ0/jvtx2T/vQGJrJR9L011YSiyvuy3PuDe\nSH5hU38CgYEAr0tPkcEgLiS70qt+1axYvjiUTiUTGuKuUAezYGvM1wLBReKCmFhY\nzEofz0Lef8hP37vwdhgpRoPg0iGUjPG9dWy0QR/6ZpPMDZBKP3Mj59+nQ4k27zdX\ntUitD7vqAUn5m9LCggZ3CwRCcbHHf50jRoJMZuyYfk2wFXKnXQP3xBMCgYEAlFsc\nLc0zfrT4LLiLU/Jz9XjOTGt+7dqXzGlplWmdeC4zSAS+leZM2OLD3p6i797Hunvt\nTjyNan5L4KbHrc+UzRavL6AwJxxTQKtw/En+hrqruGO6P4UMA7bH+fWQOilR+Hoe\n/pnlGjJSnxbtDaB12RPbPAqbwVsEK/36DHaMuT8CgYB0YSwgI3R2QmawhgYeuVi9\nF3Xa1NmY9UfpmJbB33TI/+dGiEtNu5LGilA5aDoBs+1FOnkoNv1LQT3PDr0hY9UJ\nXLRyaxSbACmM58mdALY/+D2WhepOjr17r/ueNOJMy1Jvwn5bY26HPsdN2V0l8aT6\n+jjxjER2luVnKjKgHlJ7yQ==\n-----END PRIVATE KEY-----\n',  'client_email': 'vizion-dev@vizion-366603.iam.gserviceaccount.com',  'client_id': '105976117141761523149',  'auth_uri': 'https://accounts.google.com/o/oauth2/auth',  'token_uri': 'https://oauth2.googleapis.com/token',  'auth_provider_x509_cert_url': 'https://www.googleapis.com/oauth2/v1/certs',  'client_x509_cert_url': 'https://www.googleapis.com/robot/v1/metadata/x509/vizion-dev%40vizion-366603.iam.gserviceaccount.com'}"
    const serviceAccount = {
      type: 'service_account',
      project_id: 'vizion-366603',
      private_key_id: 'a9bdf00f5f3d95d40197c65ab1c54314cb935924',
      private_key:
        '-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQCRwRnCFIy3kOHo\ndjwDlMY5e0yz+i9+OM78R6bjbqiAGgSubBvVz4Nq3nGQWh4BIhP5pHeISTxQ6M0T\nNd67O8df+V8QdVMFsg5AiXLkNqulCVAUbUx4nhaXeheRCOAuJl7jM3ZzVFDIDRIk\nAz8nd2am8hgoQLuMt5FQ/eLlbt4mNY/6O0TF3xJGfq4dB/3LFHUuN4d7UWbYrHTb\nNedgaUBogA3pHz77/DhKy9d1stJz2vMK387jvtrbi6sZDTE2Argl3vDaLJ/ex+9N\nI6FIzRAhAcjsnKxn2rWzlQAb+3e/CB5aejXT1Y3YjHIMoAiWbjxoLMV/aX+XUazF\n1bw952QBAgMBAAECgf951vGxS3xV9sbhi/SfCb6qTmfQC1OoL9TXDw5zEA3LB/Th\n2X1rPgydSVWlVa+/Qr1v8gv54T6KZBEJ/f4yhcYkdFEDcQ/1suI3EK76FrllPGO0\nr6k9Kum3tlf85W6BJZIsWtipj9H3aPXBJPWmCCnHZJjNDU+6Ubkn+xOwtvz88oZ1\nVAselF79l5xtnR0vEj1fmFA4NSQWgHn1egSAXVL1QjSIssWVpxwTamqsL6uMQSEB\nsUDj+vDQ9dGBL/0y150g1ZPFjVPYoCPN8QbYTLmkIDwKRVXyZow0CHmWhfU2Latg\nmUTcMj7MuawC7tg4e56t3rwe2cpolN9JPyYzs1kCgYEAwatHZfxxkUXkTLHc76LG\nb531mAHnft3Aegm5k+gdL5h1zX9Rax055+NcnZE5kbrjQO/QFnqEwJYlry2h3ovd\nAU7vp+jzz4k+o45TMiqyPZ3vo+OLbXNL61acvM4j4rAiV9M2r93toV8/lQ8mFT6P\nJggvuBacioZFKKtnYUR9CH8CgYEAwKoLMf1RZzLj1Dw+vkACJobim/UzpKLTYSVH\nt/ttxQ/w71DMQ/r2HnxWtjK0p+tNBFXkWAND3+XQ43Aygg2ji884m/Sn8oye2GPN\nDBVXJlIzyevApZLHnpNNlRpnrUzwryJ0/jvtx2T/vQGJrJR9L011YSiyvuy3PuDe\nSH5hU38CgYEAr0tPkcEgLiS70qt+1axYvjiUTiUTGuKuUAezYGvM1wLBReKCmFhY\nzEofz0Lef8hP37vwdhgpRoPg0iGUjPG9dWy0QR/6ZpPMDZBKP3Mj59+nQ4k27zdX\ntUitD7vqAUn5m9LCggZ3CwRCcbHHf50jRoJMZuyYfk2wFXKnXQP3xBMCgYEAlFsc\nLc0zfrT4LLiLU/Jz9XjOTGt+7dqXzGlplWmdeC4zSAS+leZM2OLD3p6i797Hunvt\nTjyNan5L4KbHrc+UzRavL6AwJxxTQKtw/En+hrqruGO6P4UMA7bH+fWQOilR+Hoe\n/pnlGjJSnxbtDaB12RPbPAqbwVsEK/36DHaMuT8CgYB0YSwgI3R2QmawhgYeuVi9\nF3Xa1NmY9UfpmJbB33TI/+dGiEtNu5LGilA5aDoBs+1FOnkoNv1LQT3PDr0hY9UJ\nXLRyaxSbACmM58mdALY/+D2WhepOjr17r/ueNOJMy1Jvwn5bY26HPsdN2V0l8aT6\n+jjxjER2luVnKjKgHlJ7yQ==\n-----END PRIVATE KEY-----\n',
      client_email: 'vizion-dev@vizion-366603.iam.gserviceaccount.com',
      client_id: '105976117141761523149',
      auth_uri: 'https://accounts.google.com/o/oauth2/auth',
      token_uri: 'https://oauth2.googleapis.com/token',
      auth_provider_x509_cert_url: 'https://www.googleapis.com/oauth2/v1/certs',
      client_x509_cert_url:
        'https://www.googleapis.com/robot/v1/metadata/x509/vizion-dev%40vizion-366603.iam.gserviceaccount.com',
    };

    const client = await auth.fromJSON(serviceAccount);
    client.scopes = ['https://www.googleapis.com/auth/analytics.readonly'];

    const tokenResult = await client.getAccessToken();

    return tokenResult.token;
  } catch (err) {
    console.error('Error getting access token:', err);
    throw err;
  }
}

export const ggAnalyticsGetToken = async () => {
  const token = await getAccessToken();
  return token;
};
